module.exports = __webpack_public_path__ + "static/img/icon_m_close_b.c6699ac2.svg";